import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import HeroSection from "../../components/hero/Hero";
import AboutSection from "../../components/about/about";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import FeatureSection from "../../components/FeatureSection/FeatureSection";
//import ProjectSection from "../../components/ProjectSection/ProjectSection";
import IndustriesMarqueeSection from "../../components/IndustriesMarqueeSection/IndustriesMarqueeSection";
import IndustriesSection from "../../components/Industries/Industries";
import ContactSection from "../../components/ContactSection/ContactSection";
import TestimonialSection from "../../components/Testimonial/Testimonial";
import BlogSection from "../../components/BlogSection/BlogSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import EngineeringReliableSilicon from "../../components/Home_Section/EngineeringReliableSilicon";
import WhoWeAre from "../../components/Home_Section/WhoWeAre";
import TrustedEngineeringEcosystem from "../../components/Home_Section/TrustedEngineeringEcosystem";
import CoreCapabilities from "../../components/Home_Section/CoreCapabilities";
import IndustryExpertise from "../../components/Home_Section/IndustryExpertise";
import CallToAction from "../../components/Home_Section/CallToAction";
import Perspective from "../../components/Home_Section/Perspective";
// import ScaleExperience from "../../components/Home_Section/ScaleExperience";
import WhyDigicomm from "../../components/Home_Section/WhyDigicomm";

const HomePage: React.FC = () => {
  useEffect(() => {
    document.title = "Home | Digicomm Semiconductor";
  }, []);

  return (
    <Fragment>
        <div className='ai-agency'>
          <div className="body_wrap o-clip">
            <Header />
            <main>
              <HeroSection/>
            {/*  <AboutSection/>*/} 
            <TrustedEngineeringEcosystem/>
               <WhoWeAre/>
              <EngineeringReliableSilicon/>
              <CoreCapabilities/> 
            {/*     <ServiceSection/>*/}
              <IndustryExpertise/>
              {/* <ScaleExperience/> */}
               <WhyDigicomm/>
               <Perspective/>
              <CallToAction/>
              
               {/*    <FeatureSection/>
              
             
                {/*  <ProjectSection/> 
              <IndustriesMarqueeSection/>
              <IndustriesSection/>
              <ContactSection/>
              <TestimonialSection/>
              <BlogSection/>*/}
            </main>
            <Footer />
            <Scrollbar />
          </div>
        </div>
    </Fragment>
  );
};

export default HomePage;
